"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var debug = require("debug");
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["debug"] = 0] = "debug";
    LogLevel[LogLevel["info"] = 1] = "info";
    LogLevel[LogLevel["warn"] = 2] = "warn";
    LogLevel[LogLevel["error"] = 3] = "error";
    LogLevel[LogLevel["none"] = 4] = "none";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
enableErrorIfEmpty();
var Logger = /** @class */ (function () {
    function Logger(module, scope) {
        this.module = module;
        this.scope = scope;
        this.debugLogFunc = debug("debug:" + module + ":" + scope);
        // tslint:disable-next-line:no-console
        this.debugLogFunc.log = console.debug.bind(console);
        this.errorLogFunc = debug("error:" + module + ":" + scope);
        // tslint:disable-next-line:no-console
        this.errorLogFunc.log = console.error.bind(console);
        this.warnLogFunc = debug("warn:" + module + ":" + scope);
        // tslint:disable-next-line:no-console
        this.warnLogFunc.log = console.warn.bind(console);
        this.infoLogFunc = debug("info:" + module + ":" + scope);
        // tslint:disable-next-line:no-console
        this.infoLogFunc.log = console.info.bind(console);
    }
    Logger.setLevel = function (logLevel) {
        var currentNamespace = getCurrentNamespace();
        var logLevelNamespace = namespaceForLogLevel(logLevel);
        if (currentNamespace.length > logLevelNamespace.length) {
            // disabling some logs
            console.warn("Log level is set to " + LogLevel[logLevel]);
        }
        debug.enable(logLevelNamespace);
    };
    Logger.prototype.warn = function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.warnLogFunc.apply(this, [message].concat(args));
    };
    Logger.prototype.info = function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.infoLogFunc.apply(this, [message].concat(args));
    };
    Logger.prototype.debug = function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.debugLogFunc.apply(this, [message].concat(args));
    };
    Logger.prototype.error = function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.errorLogFunc.apply(this, [message].concat(args));
    };
    return Logger;
}());
exports.Logger = Logger;
function getCurrentNamespace() {
    var namespace = debug.disable();
    debug.enable(namespace);
    return namespace;
}
function namespaceForLogLevel(logLevel) {
    return Object.keys(exports.LogLevel)
        .filter(function (key) { return !isNaN(Number(key)) && Number(key) >= logLevel; })
        .map(function (key) { return LogLevel[key]; })
        .map(function (value) { return value + ':*'; })
        .join(',');
}
function enableErrorIfEmpty() {
    if (!getCurrentNamespace()) {
        debug.enable('error:*');
    }
}
//# sourceMappingURL=logger.js.map